import moment from 'moment';

const ReviewBox = ({ createdAt, revName, revSurname, text, rating }) => {
    const stars = Array.from({ length: rating });
    const formatted = moment(createdAt).format('DD/MM/YYYY HH:mm:ss');
    return (
        <div className="flex flex-col border border-cyan-600 rounded-lg p-2 w-full">
            <h4 className="text-xs">{revName} {revSurname}</h4>
            <h4 className="text-xs">{formatted}</h4>
            <div className="flex">
                {
                    stars.map((element, index) => (
                        <i class="fi fi-sr-star text-orange-500" key={index}></i>
                    ))
                }
            </div>

            <p>{text}</p>

        </div>
    )
}

export default ReviewBox;